import React from "react"
import ReactDOM from "react-dom"
import { ThemeProvider } from "@material-ui/core"
import { BrowserRouter } from "react-router-dom"
import { debugContextDevtool } from "react-context-devtool"

import GlobalStateProvider from "@/store/GlobalState"
import PermissionStateProvider from "@/store/PermissionState"
import AccessibleDrawerStateProvider from "@/store/AccessibleDrawerState"
import { isDevEnv } from "@/utils/environment"

import ObservabilityService from "@/services/Observability"
import AnalyticsService from "@/services/Analytics"
import StorageService from "@/services/Storage"

import GlobalErrorBoundary from "@/components/GlobalErrorBoundary"
import App from "@/App"
import ServiceWorkerRegistrator from "@/services/ServiceWorkerRegistrator"

import theme from "@/styles/theme"

import "@/styles/global.css"
import "react-vis/dist/style.css"

const container = document.getElementById("root")

ObservabilityService.setup()
AnalyticsService.setup()

const LEGACY_UPSELL_DIALOG_USER_PREFERENCE_STORAGE_KEYS = [
	"inbox:show-admin-upsell-dialog",
	"inbox:user-preference:ai-text-enhancement-admin-upsell-dialog",
	"inbox:user-preference:attendance-summary-upsell-dialog"
]

LEGACY_UPSELL_DIALOG_USER_PREFERENCE_STORAGE_KEYS.forEach(legacyStorageKey => StorageService.delete(legacyStorageKey))

ReactDOM.render(
	<React.StrictMode>
		<ThemeProvider theme={theme}>
			<GlobalErrorBoundary>
				<BrowserRouter>
					<GlobalStateProvider>
						<PermissionStateProvider>
							<AccessibleDrawerStateProvider>
								<App />
							</AccessibleDrawerStateProvider>
						</PermissionStateProvider>
					</GlobalStateProvider>
				</BrowserRouter>
			</GlobalErrorBoundary>
		</ThemeProvider>
	</React.StrictMode>,
	container
)

// To make use of the context debug it is necessary to install the extension
// https://github.com/deeppatel234/react-context-devtool
debugContextDevtool(container, {
	disable: !isDevEnv
})

ServiceWorkerRegistrator.register()
